import React, { useEffect, useState } from 'react';
import { Flex, CircularProgress, Center, Text, Box, useTheme } from '@chakra-ui/react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { refreshUserData, setSignedIn, setTokenData } from '../../redux/reducers';
import { useLocalStorage } from '../../hooks';
import LoginForm from './loginForm';
import CreateUserForm from './createUserForm';
import { BlackLogo } from '../../images';
import { Footer } from '../';

const LoginPage = ({ history, registration }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [token, setToken] = useLocalStorage('token', null);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    // check if token is stored
    if (token != null) {
      const now = moment();
      const expiryTime = moment(token.expiryTimeStr || 'invalid');
      if (
        expiryTime.isValid() &&
        now.isBefore(expiryTime) &&
        token.access_token != null &&
        token.refresh_token != null
      ) {
        // update token
        dispatch(
          setTokenData({
            access_token: token.access_token,
            refresh_token: token.refresh_token,
            expiryTime,
          })
        );

        // set user to be signed in
        dispatch(setSignedIn(true));

        // refresh user data
        dispatch(refreshUserData())
          .then(() => {
            history.push('/interpreter');
          })
          .catch((err) => {
            console.warn('Failed to refresh user data', err);
          });
      } else {
        // loaded
        setLoading(false);
      }
    } else {
      // loaded
      setLoading(false);
    }
  }, [setLoading]);

  return (
    <Flex
      height="100vh"
      backgroundColor="brand.50"
      flexDirection="column"
      alignItems="center"
      overflowY="auto"
    >
      <Flex flexGrow={1} flexDirection="column" width="280px" mt={120} mb={10}>
        <Flex justifyContent="center">
          <BlackLogo />
        </Flex>
        <Text
          align="center"
          mt={4}
          color="white"
          fontSize="4xl"
          fontWeight="bold"
          textAlign="center"
        >
          {t('chabla').toUpperCase()}
        </Text>
        {loading === false && !registration && <LoginForm setToken={setToken} />}
        {loading === false && registration && <CreateUserForm />}
        {loading === true && (
          <Center>
            <CircularProgress isIndeterminate size={35} />
          </Center>
        )}
      </Flex>
      <Box
        height="150px"
        width="100%"
        position="static"
        // linear-gradients shouldn't change in the middle since it creates jagged edges
        bgImage={`linear-gradient(to right top, ${theme.colors.white} 0%, ${theme.colors.white} 49.5%, transparent 50.5%)`}
      />
      <Box height="100px" width="100%" position="static" backgroundColor="white" />
      <Footer width="100%" />
    </Flex>
  );
};

LoginPage.propTypes = {
  history: PropTypes.any,
  registration: PropTypes.bool,
};

export default withRouter(LoginPage);
